import React, { useEffect, useState } from "react";
import Axios from "axios";
import TeamCard from "./TeamCard";
import Overlay from "./Overlay";
import Modal from "./Modal";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardSkeleton from "./CardSkeleton";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const slideIn = {
	visible: { opacity: 1, translateX: 0 },
	hidden: { opacity: 0, translateX: -200 },
};

const Index = () => {
	//intersection observer
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.2,
	});

	// MODAL FUNCTION
	const [open, setOpen] = useState(false);
	const openModal = () => setOpen(true);
	const closeModal = () => setOpen(false);

	//LOADING SKELETON
	const [isLoading, setIsLoading] = useState(true);

	//CAROUSEL CARDS SETTING CONFIGURATION
	const responsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: 5,
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 3,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 1,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};

	//HANDLING API CALL
	const [teamData, setTeamData] = useState([]);
	useEffect(() => {
		Axios.get("https://website-backend-taupe.vercel.app/api/team").then(
			(response) => {
				setTeamData(response.data);
				setIsLoading(false);
			}
		);
	}, []);
	const sortedData = teamData.sort((a, b) => a.Priority - b.Priority);

	//PASSING API DATA TO THE CARD COMPONENT
	const cards = sortedData.map((item) => {
		return (
			<SplideSlide>
				<TeamCard
					department={item["Department"]}
					open={(department) => {
						setSelectedDepartment(department);
						openModal();
					}}
					key={item.id}
					designation={item["designation "]}
					content={item["content "]}
					{...item}
				/>
			</SplideSlide>
		);
	});

	const [selectedDepartment, setSelectedDepartment] = useState(null);

	return (
		<section id="teams" className="py-6 bg-black text-gray-100">
			{/* -------------------------------- CONTAINER ------------------------------- */}
			<motion.div
				ref={ref}
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={slideIn}
				transition={{ duration: 0.8, ease: "easeIn" }}
				className="container flex flex-col items-center justify-center p-4 mx-auto sm:p-10"
			>
				{/* --------------------------------- HEADING -------------------------------- */}
				<p className="p-2 text-lg font-medium tracking text-center uppercase text-secondary">
					Our team
				</p>
				<h1 className="text-3xl md:text-4xl font-popp font-semibold text-center mb-12">
					Meet the minds behind the club's success
				</h1>

				{/* ---------------------------------- CARD ---------------------------------- */}
				{window.screen.width < 768 ? (
					<Splide
						options={{
							type: "loop",
							perPage: 1,
							perMove: 1,
							gap: "1rem",
							pagination: false,
							breakpoints: {
								640: {
									perPage: 1,
									perMove: 1,
								},
								768: {
									perPage: 2,
									perMove: 1,
								},
								1024: {
									perPage: 3,
									perMove: 1,
								},
							},
						}}
						className="w-full"
					>
						{isLoading && <CardSkeleton cards={10} />}
						{cards}
					</Splide>
				) : (
					<div
						className="grid 2xl:grid-cols-4 lg:grid-cols-3 lg:gap-28 md:grid-cols-2 md:gap-20"
						style={{ perspective: 1000 }}
					>
						{isLoading && <CardSkeleton cards={10} />}
						{cards}
					</div>
				)}

				{/* ---------------------------------- Modal --------------------------------- */}
				{open && (
					<Overlay close={closeModal}>
						{
							<Modal
								department={selectedDepartment}
								close={closeModal}
							/>
						}
					</Overlay>
				)}
			</motion.div>
		</section>
	);
};

export default Index;
